export function getStorage (str) {
  return localStorage.getItem(str)
}

export function setStorage (str,obj) {
  return localStorage.setItem(str, obj)
}

export function removeStorage (str) {
    return localStorage.removeItem(str)
}

export default{
  getStorage,
  setStorage,
  removeStorage,
}


// WEBPACK FOOTER //
// ./src/service/auth.js